// extracted by mini-css-extract-plugin
export default {"buttonBar":"page_buttonBar__YxlwV"};